module.exports = __webpack_public_path__ + "img/Group@2x.5b269128.svg";